import { requests, mainApiRoot } from './index'

export const Users = {
  getAll: () => requests.get(mainApiRoot, '/account/users/'),
  get: id => requests.get(mainApiRoot, `/account/users/${id}`),
  create: payload => requests.post(mainApiRoot, '/account/users/', { user: payload }),
  update: (id, payload) => requests.put(mainApiRoot, `/account/users/${id}`, { user: payload }),
  del: id => requests.del(mainApiRoot, `/account/users/${id}`),
  domainAccess: (id, payload) =>
    requests.put(mainApiRoot, `/account/domain-access/${id}`, payload),
  getEmailNotifications: () => requests.get(mainApiRoot, '/account/email-notifications/'),
  setEmailNotifications: (id, payload) =>
    requests.put(mainApiRoot, `/account/email-notifications/${id}`, payload)
}
